// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// These two lines make Kaido work on IE10
// import 'core-js/stable';
// import 'regenerator-runtime/runtime';

// Import the rangeslider used in surveys
import "rangeslider.js/dist/rangeslider.js";

window.Rails = require("@rails/ujs");

// window.Rails.start()

// require("@rails/activestorage").start()
// require("channels")

window.$ = window.jQuery = require("jquery");
window.loadImage = require("blueimp-load-image");

// var Turbolinks = require("turbolinks")
// Turbolinks.start()
// Turbolinks.setProgressBarDelay(0)

window.Chart = require("chart.js");

// require("../src/reflection_form.coffee")
// require("../src/tasks_form.coffee")
require("../src/confirm.js");
require("../src/auth_token_dispatch.js");
require("../src/auth_token.js");
require("../src/platform_specific.js");
require("../src/intercom.js");
require("../src/progress_bar.js");
require("../src/turbolinks_get_form.js");
require("../src/refresh_tokens.js");
require("../src/scroll_to_setup_step.js");
require("../src/challenge_booster_select.js");
require("../src/required_fields_form.js");
require("../src/image_field.js");
require("better-dom/dist/better-dom.js");
require("better-dateinput-polyfill/dist/better-dateinput-polyfill.js");

window.legacyPreviewImage = function () {
  var preview = document.querySelector(".file-selector .img");
  var file = document.querySelector(".file-selector input[type=file]").files[0];
  var reader = new FileReader();

  loadImage.parseMetaData(file, function (data) {
    var orientation = 0;

    if (data.exif) {
      orientation = data.exif.get("Orientation");
    }

    loadImage(
      file,
      function (canvas) {
        var image = canvas.toDataURL("image/jpeg");
        preview.style.backgroundImage = "url(" + image + ")";

        // Focus the Save Image button after preview loads
        setTimeout(function () {
          var saveButton = document.querySelector(
            ".file-selector .selected .ok-button"
          );
          if (saveButton) {
            saveButton.focus();
          }
        }, 100);
      },
      {
        canvas: true,
        orientation: orientation,
      }
    );
  });
};
